"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("mktHistoryCalendar", function (indexationService, fixingService, mktHistoryUtils, $debounce, $timeout) {
  return {
    restrict: "E",
    scope: {
      reference: "=",
      date: "="
    },
    replace: true,
    controllerAs: "calendarCtrl",
    template: require("./mktHistoryCalendar.html"),
    controller: function controller($scope) {
      var ctrl = this;
      $scope.calendarConfig = {
        hideWeekends: true,
        date: $scope.date
      };
      $scope.$watch("reference", function (reference) {
        ctrl.loadMonthlyFixings();
      }, true);
      $scope.$watch("date", function (date) {
        $scope.calendarConfig.date = date;
        ctrl.loadMonthlyFixings();
      });
      var currentMonth = null,
        currentYear = null,
        currentReference = null;
      ctrl.loadMonthlyFixings = $debounce(function () {
        var calendarDate = $scope.calendarConfig.date,
          month = moment(calendarDate).month(),
          year = moment(calendarDate).year(),
          reference = $scope.reference;
        var spread = reference != null && reference.type === 'SPREAD';
        var reference1,
          reference2 = null;
        if (spread) {
          reference1 = reference.reference1;
          reference2 = reference.reference2;
          if (!(mktHistoryUtils.isReferenceValid(reference1) && mktHistoryUtils.isReferenceValid(reference2))) {
            $scope.fixingsMap = {};
            return;
          }
        } else if (!mktHistoryUtils.isReferenceValid(reference)) {
          $scope.fixingsMap = {};
          return;
        }
        if (month === currentMonth && year === currentYear && mktHistoryUtils.isSameReference(currentReference, reference)) {
          return;
        }
        currentMonth = month;
        currentYear = year;
        currentReference = angular.copy(reference);
        ctrl.isLoading = true;
        if (spread) {
          return fixingService.getMonthlySpreadFixings(reference1, reference2, month, year).then(function (fixings) {
            $scope.fixingsMap = fixings;
            $timeout(function () {
              ctrl.isLoading = false;
            }, 0);
          });
        } else {
          return fixingService.getMonthlyFixings(reference, month, year).then(function (fixings) {
            $scope.fixingsMap = fixings;
            $timeout(function () {
              ctrl.isLoading = false;
            }, 0);
          });
        }
      }, 100);
      ctrl.getReferenceIndexType = function () {
        var reference = $scope.reference;
        if (reference.type === "INDEX") {
          var indice = indexationService.getIndice(reference.indexId);
          return indice && indice.type || "TAUX";
        } else {
          // hardcoded for now for indexations
          return "TAUX";
        }
      };
    }
  };
});
ngModule.directive('mktCalendarCellTemplate', function ($numberFormat) {
  return {
    restrict: "E",
    require: "^mktHistoryCalendar",
    scope: true,
    replace: true,
    template: '' + '<div class="mkt-cal-cell">' + '   <div class="day">' + '       {{day}}' + '   </div>' + '   <div class="value" ng-switch="fixing.state">' + '       <span ng-switch-when="CLOSED_MARKET_DAY">' + '           <i class="fa fa-moon-o"></i>' + '       </span>' + '       <span ng-switch-default>' + '           {{indexValue}}' + '       </span>' + '   </div>' + '</div>',
    link: function link($scope, $el, $attr, calendarCtrl) {
      $scope.indexValue = "-";
      $scope.fixing = null;
      var refreshIndexValue = function refreshIndexValue() {
        var monthMap = $scope.fixingsMap;
        var fixing = $scope.fixing = monthMap ? monthMap[$scope.day] : null;
        if (fixing != null) {
          var indexType = calendarCtrl.getReferenceIndexType();
          var usePercentage = indexType === "TAUX";
          var formattedIndexValue = $numberFormat[usePercentage ? "percentage" : "number"](fixing.valeur, 4);
          if (fixing.type === "ESTIME") {
            formattedIndexValue += "*";
          }
          $scope.indexValue = formattedIndexValue;
        } else {
          $scope.indexValue = "-";
        }
      };
      $scope.$watch("fixingsMap", refreshIndexValue);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/historique/mktHistoryCalendar.js
// module id = 2846
// module chunks = 13